// 直连创建预订
import { MemberLevel, CertIDType } from '@/config/constant';
import { CRSReserveCreateAction } from '@/redux/actions/reservation/constant';
import {
  RentTimeInfo,
  RentRoomInfo,
  RemarkInfo,
  SourceChannelFullInfo,
  RoomCategory,
} from './base.d';

// 预订人信息
interface CustomerInfo {
  name: string;
  mobile: string;
  certNo: string;
  memberLevel: MemberLevel;
  wyuId: string;
  realPhoneNo: string; // 真实手机号
  certType: CertIDType; // 证件类型
  email: string;
}

export interface ChannelInfo extends SourceChannelFullInfo {
  channelType: string; // 渠道类型
  // otaOrderNo: string; // ota订单号
}

export interface MainState {
  customerInfo: CustomerInfo; // 预订人信息
  rentTimeInfo: RentTimeInfo; // 入住日期
  channelInfo: ChannelInfo; // 客源渠道
  rentRoomInfos: RentRoomInfo[]; // 入住房间
  remarkInfo: RemarkInfo; // 备注
}

export interface ReducerState extends MainState {
  isInit: boolean; // 初始化
  isLoading: boolean; // 加载中
  isModify: boolean; // 是否有修改
  allRoomList: RoomCategory[]; // 房间列表
  rentBaseInfo: any; // 房源信息
}

const initialState: Partial<ReducerState> = {
  isInit: false,
  isLoading: true,
  isModify: false,
};

type ActionHandler<T> = (state: ReducerState, action: { payload: T }) => ReducerState;

const reducerMap = {
  [CRSReserveCreateAction.initDefaultState]: <ActionHandler<Partial<ReducerState>>>((
    state,
    { payload },
  ) => {
    return { ...state, ...payload };
  }),
  [CRSReserveCreateAction.setLoadingStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, isLoading: payload };
  }),
  [CRSReserveCreateAction.setInitStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, isInit: payload };
  }),
  [CRSReserveCreateAction.setModifyStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, isModify: payload };
  }),
  [CRSReserveCreateAction.setRentRoomList]: <ActionHandler<RentRoomInfo[]>>((
    state,
    { payload },
  ) => {
    return { ...state, rentRoomInfos: payload };
  }),
  [CRSReserveCreateAction.setAllRoomList]: <ActionHandler<RoomCategory[]>>((state, { payload }) => {
    return { ...state, allRoomList: payload };
  }),
};

export const reducerMapper = (state = initialState, action) => {
  const actionType = action.type;
  const reducer = reducerMap[actionType];
  if (typeof reducer === 'function') {
    return reducer(<ReducerState>state, action);
  }
  return state;
};

export const storeName = 'reserveCreate4CRS';
